export enum OrderActionKeys {
  FETCH_OPEN_ORDERS = 'FETCH_OPEN_ORDERS',
  FETCH_ORDER = 'FETCH_ORDER',
  FETCH_ORDER_FULFILLED = 'FETCH_ORDER_FULFILLED',
  FETCH_ORDER_REJECTED = 'FETCH_ORDER_REJECTED',
  SET_OPEN_ORDERS = 'SET_OPEN_ORDERS',
  SET_MIN_ORDERS = 'SET_MIN_ORDERS'
}
